import { render } from "./LandmarksDialog.vue?vue&type=template&id=781f6880&scoped=true"
import script from "./LandmarksDialog.vue?vue&type=script&lang=js"
export * from "./LandmarksDialog.vue?vue&type=script&lang=js"

import "./LandmarksDialog.vue?vue&type=style&index=0&id=781f6880&scoped=true&lang=css"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781f6880"]])

export default __exports__